var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "tabs",
        {
          ref: "tabs_dom",
          attrs: { options: { useUrlFragment: false } },
          on: { changed: _vm.update_dataV },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("li", { staticClass: "tabs-component-tab" }, [
                    _c(
                      "a",
                      {
                        staticClass: "tabs-component-tab-a",
                        on: { click: _vm.show_help }
                      },
                      [_vm._v("\n                  帮助 Ⓗ\n              ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.tab_name == "贝叶斯计算器" && !_vm.show_case
                    ? _c("li", { staticClass: "tabs-component-tab" }, [
                        _c(
                          "a",
                          {
                            staticClass: "tabs-component-tab-a",
                            on: { click: _vm.page_return }
                          },
                          [_vm._v("\n                  返回 ↶\n              ")]
                        )
                      ])
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "tab",
            { attrs: { name: "贝叶斯原理", hash: "BayesTheory" } },
            [_c("bayes-theory")],
            1
          ),
          _vm._v(" "),
          _c(
            "tab",
            { attrs: { name: "贝叶斯计算器", hash: "BayesCaculator" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.load_done,
                      expression: "load_done"
                    }
                  ],
                  staticClass: "row"
                },
                [
                  _c("left-side-bar", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show_panel,
                        expression: "show_panel"
                      }
                    ]
                  }),
                  _vm._v(" "),
                  _c("bayes-caculator", {
                    ref: "calc_dom",
                    on: {
                      toggle_panel: function($event) {
                        _vm.show_panel = !_vm.show_panel
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("bayes-case", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show_case,
                    expression: "show_case"
                  }
                ],
                ref: "case_dom",
                staticStyle: { position: "absolute", inset: "0px" },
                on: { select_case: _vm.select_case }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tab",
            { attrs: { name: "贝叶斯分类器", hash: "BayesClassfier" } },
            [_c("bayes-classifier")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.show_guide
        ? _c(
            "div",
            { class: "overlayer-guide " + (_vm.model ? "model" : "") },
            [
              _vm.tab_name == "贝叶斯计算器" && _vm.show_case
                ? _c("bayes-case-guide", {
                    on: {
                      chg_idx: _vm.guide_idx,
                      skip: _vm.skip_guide,
                      guide_over: _vm.guide_over
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.tab_name == "贝叶斯计算器" && !_vm.show_case
                ? _c("caculator-guide", {
                    on: {
                      chg_idx: _vm.guide_idx,
                      skip: _vm.skip_guide,
                      guide_over: _vm.guide_over
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }